import { PostsProps } from "../posts/Posts";

const addOneReaction = (total_curated_reactions: PostsProps.Count) => {
  const newTotal = Number(`${total_curated_reactions}`);
  if (isNaN(newTotal)) return total_curated_reactions;
  return newTotal + 1;
};
const removeOneReaction = (total_curated_reactions: PostsProps.Count) => {
  const newTotal = Number(`${total_curated_reactions}`);
  if (isNaN(newTotal)) return total_curated_reactions;
  return newTotal - 1;
};

export const ReactionsUtils = { addOneReaction, removeOneReaction };
